import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Emitter from '../../services/emitter';
import './dragholder.less';
const showClass = 'dragload-holder-show';

class DragHolder extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showClass: ''
        };
        this.listeners = {};
    }

    componentDidMount() {
        this.addListener();
    }

    componentWillUnmount() {
        this.removeListener();
    }

    addListener() {
        const checkFile = (e) => {
            const types = e.dataTransfer.types;
            return !(_.isArray(types) && types.indexOf('Files') === -1);
        };

        this.listeners = {
            drop: (e) => {
                const { pathname } = this.props.location;
                if (pathname === '/list') {
                    return;
                }
                this.preventDefault(e);
                if (checkFile(e)) {
                    this.dragOpenFile(e.dataTransfer.files[0]);
                    this.hideHolder();
                }
                return false;
            },
            dragover: (e) => {
                const { pathname } = this.props.location;
                if (pathname === '/list') {
                    return;
                }
                this.preventDefault(e);
                if (checkFile(e)) {
                    this.showHolder();
                }
                return false;
            },
            dragleave: (e) => {
                const { pathname } = this.props.location;
                if (pathname === '/list') {
                    return;
                }
                this.preventDefault(e);
                this.hideHolder();
                return false;
            },
            dragend: (e) => {
                const { pathname } = this.props.location;
                if (pathname === '/list') {
                    return;
                }
                this.preventDefault(e);
                this.hideHolder();
                return false;
            }
        };
        for (var event in this.listeners) {
            document.body.addEventListener(event, this.listeners[event]);
        }
    }

    removeListener() {
        for (var event in this.listeners) {
            document.body.removeEventListener(event, this.listeners[event]);
        }
    }

    preventDefault(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    hideHolder() {
        if (this.state.showClass !== '') {
            this.setState({
                showClass: ''
            });
        }
    }

    showHolder() {
        if (this.state.showClass === '') {
            this.setState({
                showClass: showClass
            });
        }
    }

    dragOpenFile(file) {
        const { pathname } = this.props.location;
        if (pathname === '/list') {
            Emitter.emit('DragAddProject', file);
        } else {
            Emitter.emit('DragOpenFile', file);
        }
    }

    render() {
        return (
            <div ref={target => this.dragloadHolder = target} className={`dragload-holder ${this.state.showClass}`}>
                <span>{this.props.intlr.messages['DRAG.HOLDER.TEXT']}</span>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});

export default withRouter(connect(
    mapStateToProps
)(DragHolder));

// export default injectIntl(DragHolder);